/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TeamPositionCreate = {
    properties: {
        teamId: {
            type: 'number',
            isRequired: true,
        },
        position: {
            type: 'PlayerPositionEnum',
            isRequired: true,
        },
    },
} as const;
